var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wtw-container size-option-container clearfix" },
    [
      _c(
        "div",
        { staticClass: "flex-grid flex-grid-column" },
        _vm._l(_vm.optionsAll, function(option, index) {
          var _obj
          return _c(
            "div",
            {
              key: option.product_option_id,
              staticClass: "select-wrapper",
              class:
                ((_obj = {
                  "select-wrapper--value-selected": _vm.optionValues[index]
                }),
                (_obj["select-wrapper--" + option.product_option_token] = true),
                _obj)
            },
            [
              _c(
                "label",
                {
                  staticClass: "size-label",
                  attrs: { for: "size-" + option.product_option_id }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(option.product_option_title) +
                      "\n                "
                  ),
                  _c("span", { staticClass: "size-select-value" }, [
                    _vm._v(_vm._s(_vm.optionValueTitles[index]))
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.optionValues[index],
                          expression: "optionValues[index]"
                        }
                      ],
                      staticClass: "size-select",
                      attrs: {
                        name: option.product_option_title,
                        id: "size-" + option.product_option_id
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.optionValues,
                              index,
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          function($event) {
                            return _vm.sizeChanged($event, option, index)
                          }
                        ]
                      }
                    },
                    [
                      _c("option", { domProps: { value: null } }, [
                        _vm._v("Select a size")
                      ]),
                      _vm._v(" "),
                      _vm._l(option.product_option_values, function(
                        optionValue
                      ) {
                        return _c(
                          "option",
                          {
                            key: optionValue.product_option_value_id,
                            domProps: {
                              value: optionValue.product_option_value_id
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(optionValue.product_option_value_title) +
                                "\n                    "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ]
              )
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e64cffd", { render: render, staticRenderFns: staticRenderFns })
  }
}